'use client';

import { createNewBit } from '@/src/actions/bits';
import { useBoolean } from '@/src/hooks/use-boolean';
import { IUIProfile } from '@/src/types/IUIProfile';
import { Button } from '@workspace/ui/components/button';
import { redirect } from 'next/navigation';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@workspace/ui/components/dropdown-menu';
import { TooltipComponent } from '../layout';
import { ERole } from 'types/src/types';
import { Icon } from '.';

type Props = {
  profile?: IUIProfile;
  isOpenModal?: () => void;
};

export const AddBitButtonOld = ({ profile }: Props) => {
  const isLoadBit = useBoolean(false);
  const handleCreateNewBit = async () => {
    isLoadBit.onTrue();
    const { data } = await createNewBit();
    if (!data) {
      console.error('Failed to create new bit');
      return;
    }
    redirect(`/${profile?.uniqueLink}/bits/draft/${data.id}`);
  };

  return (
    <Button
      className="md:flex hidden p-3 md:text-sm md:p-2 md:h-7!"
      onClick={handleCreateNewBit}
      size="sm"
    >
      Add new Bit
    </Button>
  );
};

export const CreateContentButton = ({ profile, isOpenModal }: Props) => {
  const isOpen = useBoolean(false);
  const isLoadBit = useBoolean(false);
  const handleCreateNewBit = async () => {
    isLoadBit.onTrue();
    const { data } = await createNewBit();
    if (!data) {
      console.error('Failed to create new bit');
      return;
    }
    redirect(`/${profile?.uniqueLink}/bits/draft/${data.id}`);
  };

  return (
    <DropdownMenu modal={false} onOpenChange={(open) => isOpen.setValue(open)}>
      <DropdownMenuTrigger asChild>
        <Button
          size="sm"
          variant="gray"
          onClick={isOpen.onToggle}
          className="cursor-pointer p-3! hover:custom-border md:h-10 size-12 md:w-fit border-0 bg-[#EDEDEF]"
        >
          <Icon name="add" className="md:size-3.5 size-5 text-black" />
          <span className="md:inline hidden">Create</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="center"
        className="p-2 gap-1 font-normal text-black/40 text-base"
      >
        <TooltipComponent
          text="Share your quick thoughts."
          className="bg-white max-w-44 text-black/40"
          side="right"
        >
          <DropdownMenuItem
            className="flex items-center gap-2 py-1 px-2 cursor-pointer"
            onClick={isOpenModal}
          >
            <Icon name="post" className="size-3.5" />
            Create Post
          </DropdownMenuItem>
        </TooltipComponent>
        <TooltipComponent
          text="Share a story with rich-text."
          className="bg-white max-w-44 text-black/40"
          side="right"
        >
          <DropdownMenuItem
            className="flex items-center gap-2 py-1 px-2 cursor-pointer"
            onClick={handleCreateNewBit}
          >
            <Icon name="bit" className="size-3.5" />
            Create Story
          </DropdownMenuItem>
        </TooltipComponent>
        {profile?.role === ERole.GAME_DEVELOPER && (
          <TooltipComponent
            text="Build a page for your Project."
            className="bg-white max-w-44 text-black/40"
            side="right"
          >
            <DropdownMenuItem
              className="flex items-center gap-2 py-1 px-2 cursor-pointer"
              onClick={() => redirect(`/project/create-new`)}
            >
              <Icon name="project" className="size-3.5" />
              Create Project
            </DropdownMenuItem>
          </TooltipComponent>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
